import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { AppShell } from './components/layout/AppShell';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { SecretarioDashboardPage } from './pages/SecretarioDashboardPage';
import { NovaDemandaPage } from './pages/NovaDemandaPage';
import { DemandaDetailRouter } from './pages/DemandaDetailRouter';
import { MinhasDemandasPage } from './pages/MinhasDemandasPage';
import { ProducaoPage } from './pages/ProducaoPage';
import { CalendarioPage } from './pages/CalendarioPage';
import { PerfilPage } from './pages/PerfilPage';
import { MinhaFilaPage } from './pages/MinhaFilaPage';
import { EquipePage } from './pages/EquipePage';
import { TimelinePage } from './pages/TimelinePage';
import { AdminUsuariosPage } from './pages/AdminUsuariosPage';
import { AdminSecretariasPage } from './pages/AdminSecretariasPage';
import { AdminWhatsappPage } from './pages/AdminWhatsappPage';
import { AprovacaoPublicaPage } from './pages/AprovacaoPublicaPage';
import { ParceiroPublicoPage } from './pages/ParceiroPublicoPage';

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loader-full"><span className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RequirePerfil({ perfis, children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!perfis.includes(user.perfil)) return <Navigate to="/" replace />;
  return children;
}

// Dashboard troca de aparência conforme o perfil — secretário vê painel
// focado em pendências dele; comunicação/admin veem pipeline + métricas.
function DashboardSwitch() {
  const { user } = useAuth();
  if (user?.perfil === 'secretario') return <SecretarioDashboardPage />;
  return <DashboardPage />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/aprovar/:token" element={<AprovacaoPublicaPage />} />
      <Route path="/parceiro/:token" element={<ParceiroPublicoPage />} />
      <Route element={<RequireAuth><AppShell /></RequireAuth>}>
        <Route index element={<DashboardSwitch />} />
        <Route path="nova-demanda" element={<NovaDemandaPage />} />
        <Route path="minhas" element={<MinhasDemandasPage />} />
        <Route path="demandas/:id" element={<DemandaDetailRouter />} />
        <Route path="demandas/:id/timeline" element={<TimelinePage />} />
        <Route path="perfil" element={<PerfilPage />} />
        <Route path="calendario" element={<CalendarioPage />} />
        <Route path="demandas" element={<ProducaoPage />} />
        <Route path="producao" element={<Navigate to="/demandas" replace />} />
        <Route path="fila" element={<RequirePerfil perfis={['comunicacao', 'admin']}><MinhaFilaPage /></RequirePerfil>} />
        <Route path="equipe" element={<RequirePerfil perfis={['comunicacao', 'admin']}><EquipePage /></RequirePerfil>} />
        <Route path="admin/usuarios" element={<RequirePerfil perfis={['admin']}><AdminUsuariosPage /></RequirePerfil>} />
        <Route path="admin/secretarias" element={<RequirePerfil perfis={['admin']}><AdminSecretariasPage /></RequirePerfil>} />
        <Route path="admin/whatsapp" element={<RequirePerfil perfis={['admin']}><AdminWhatsappPage /></RequirePerfil>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
